/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  TOGGLE_ITEM_IN_WISH_LIST (state, item) {
    const index = state.wishList.findIndex(i => i.objectID === item.objectID)
    if (index < 0) {
      state.wishList.push(item)
    } else {
      state.wishList.splice(index, 1)
    }
  },
  REMOVE_ITEM_FROM_CART (state, payload) {
    const index = state.cartItems.findIndex(i => i.cartItemID === payload.cartItemID)
    if (index > -1) { state.cartItems.splice(index, 1) }
  },
  ADD_ITEM_IN_CART (state, item) {
    state.cartItems.push(Object.assign({}, item))
  },
  UPDATE_ITEM_QUANTITY (state, payload) {
    const index = state.cartItems.findIndex(i => i.cartItemID === payload.cartItemID)
    if (index > -1) { state.cartItems[index].quantity = payload.newValue }
  },
  ADD_PRODUCTS (state, payload) {
    state.products = payload;
  },
  ADD_CATEGORIES (state, payload) {
    state.categories = payload;
  },
  CART_SAVE_SHIPPING_ADDRESS(state, payload) {
    state.shippingAddress = payload;
  },
  CART_SAVE_PAYMENT_METHOD(state, payload) {
    state.paymentMethod = payload;
  },
  SET_SDK_READY(state, payload) {
    state.sdkReady = payload
  },
  ORDER_SUBMITTED_SUCCESS(state) {
    state.orderSubmitted = true;
  },
  ORDER_SUBMITTED_FAILED(state) {
    state.orderSubmitted = false;
  },
  ORDER_PAID_SUCCESS(state, payload) {
    state.paid = payload;
  },
  ORDER_PAID_FAILED(state, payload) {
    state.paymentFailed = payload;
  },
  
}

